import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <header className="bg-[#1B3A6B] pt-12 pb-12 lg:pt-20 lg:pb-20 min-h-[100svh] flex flex-col justify-center overflow-hidden relative" data-id="element-60">
      <div className="container mx-auto px-4 relative z-10" data-id="element-61">
        <div className="max-w-5xl mx-auto text-center flex flex-col items-center" data-id="element-62">
          <motion.div initial={{
          opacity: 0,
          y: -10
        }} animate={{
          opacity: 1,
          y: 0
        }} className="inline-block bg-[#FF6B35] text-white font-poppins font-bold px-4 py-1 rounded-full text-[10px] md:text-xs mb-3" data-id="element-63">
            🇦🇷 EXCLUSIVO PARA ARGENTINA
          </motion.div>

          <h1 className="text-white font-poppins font-black md:text-6xl lg:text-7xl mb-3 md:mb-4 tracking-tight text-[24px]" data-id="element-64">
            El protocolo que tu escuela estaba esperando.
          </h1>

          <p className="text-[#FFD700] font-poppins font-bold md:text-2xl mb-4 md:mb-5 opacity-90 text-[20px]" data-id="element-65">
            Para docentes y directivos de nivel primario.
          </p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="relative w-full max-w-[400px] md:max-w-[512px] mb-4 md:mb-6" data-id="element-66">
            <div className="absolute inset-0 bg-[#FFD700] blur-[60px] opacity-15 pointer-events-none rounded-full" data-id="element-67"></div>
            <div className="absolute inset-x-0 bottom-0 h-[60%] bg-[#FF6B35] blur-[60px] opacity-10 pointer-events-none rounded-full" data-id="element-68"></div>
            <img src="https://cdn.magicpatterns.com/uploads/jDAXhxjxV9ZnU6Szr5o8Ci/hf_20260516_014636_b9a560bd-ba8b-46b3-9ff6-c3ac93ecd784-removebg-preview.png" alt="CÓDIGO DE EMERGENCIA ESCOLAR™ NIVEL PRIMARIO" className="relative z-10 w-full h-auto drop-shadow-[0_20px_40px_rgba(0,0,0,0.4)] pt-[-10px] pb-[-10px] mt-[-45px] mb-[-45px]" loading="eager" decoding="async" width="640" height="640" sizes="(max-width: 768px) 90vw, 512px"
          // @ts-ignore
          fetchpriority="high" data-id="element-69" />
          </motion.div>

          <div className="flex flex-col items-center gap-4 md:gap-5 z-20 relative" data-id="element-70">
            <CTAButton href="#pricing" className="w-full md:w-auto shadow-[0_0_30px_rgba(255,215,0,0.3)]" data-id="element-71">
              → QUIERO EL SISTEMA AHORA
            </CTAButton>

            <div className="flex flex-wrap justify-center gap-2 md:gap-3" data-id="element-72">
              <div className="bg-white/5 text-white/90 border border-white/10 px-3 py-1.5 rounded-full text-[10px] md:text-xs font-bold flex items-center gap-2" data-id="element-73">
                📄 100% PDF Digital
              </div>
              <div className="bg-white/5 text-white/90 border border-white/10 px-3 py-1.5 rounded-full text-[10px] md:text-xs font-bold flex items-center gap-2" data-id="element-74">
                ⚡ Acceso en 5 min
              </div>
              <div className="bg-white/5 text-white/90 border border-white/10 px-3 py-1.5 rounded-full text-[10px] md:text-xs font-bold flex items-center gap-2" data-id="element-75">
                🔒 Garantía 7 días
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-76">
        <div className="absolute top-[-10%] right-[-10%] w-[40%] h-[40%] bg-[#FFD700] opacity-5 blur-[70px] rounded-full" data-id="element-77"></div>
        <div className="absolute bottom-[-10%] left-[-10%] w-[40%] h-[40%] bg-[#FF6B35] opacity-5 blur-[70px] rounded-full" data-id="element-78"></div>
      </div>
    </header>;
}